var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-bar-button-link",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"ico",attrs:{"src":_vm.icoUrl,"alt":_vm.title}}),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }